import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import { GET_ORDER_REVIEW_REQUEST } from "./actionTypes";
import { getOrderReviewResponse } from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getOrderReview({ payload: { orderId } }) {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/OrderReview/GetByOrderId/" + orderId,
      ""
    );
    yield put(getOrderReviewResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchOrderReview() {
  yield takeEvery(GET_ORDER_REVIEW_REQUEST, getOrderReview);
}

function* orderReviewSaga() {
  yield all([fork(watchOrderReview)]);
}

export default orderReviewSaga;
